// extracted by mini-css-extract-plugin
export var active = "ConfirmQtyModal-module--active--R+s+0";
export var tab = "ConfirmQtyModal-module--tab--kRV3-";
export var tabs = "ConfirmQtyModal-module--tabs--vLxNB";
export var wrapper = "ConfirmQtyModal-module--wrapper--C32FB";